
import { OnlineTimeSettingsScreenNavigationProps } from "./types"
import React from "react"
import OnlineTimeSettings from "./online-time-settings-screen"
import { PageRoot } from "~screens/page-root"


// 上线时间设置
const OnlineTimeSettingsScreen: React.FC<OnlineTimeSettingsScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <OnlineTimeSettings route={route}/>
    </PageRoot>
  )
}

export default OnlineTimeSettingsScreen
